import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

interface DemoBookingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DemoBookingDialog = ({ open, onOpenChange }: DemoBookingDialogProps) => {
  useEffect(() => {
    if (open) {
      // Track demo dialog opened
      trackEvent('demo_booking_opened', {
        category: 'conversion',
        label: 'demo_dialog',
      });

      // Load HubSpot meetings embed script when dialog opens
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      script.async = true;
      document.body.appendChild(script);

      // Track when user interacts with the booking form
      const iframe = document.querySelector('.meetings-iframe-container iframe') as HTMLIFrameElement;
      if (iframe) {
        iframe.addEventListener('load', () => {
          trackEvent('demo_booking_started', {
            category: 'conversion',
            label: 'hubspot_form_loaded',
          });
        });
      }

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Book a Demo</DialogTitle>
        </DialogHeader>
        <div 
          className="meetings-iframe-container" 
          data-src="https://meetings.hubspot.com/tom-franey/ommni-demo?embed=true"
        />
      </DialogContent>
    </Dialog>
  );
};

export default DemoBookingDialog;
